import { PartnerFormData } from './schema'

type DefaultPartnerFormValues = Omit<
  PartnerFormData,
  | 'has_cnh'
  | 'government_employee'
  | 'contributor_inss'
  | 'is_other_company_partner'
  | 'race'
  | 'marital_status'
  | 'joint_property_regime'
> & {
  has_cnh: string
  government_employee: string
  contributor_inss: string
  is_other_company_partner: string
  race: string
  marital_status: string
  joint_property_regime: string
}

export const defaultPartnerFormValues: DefaultPartnerFormValues = {
  profession: '',
  name: '',
  rg: '',
  tax_id: '',
  phone: '',
  email: '',
  marital_status: '',
  joint_property_regime: '',
  county_of_birth: '',
  specializations: [],
  nationality: '',
  address: {
    zip_code: '',
    street: '',
    number: '',
    complement: '',
    district: '',
    ibge_code: '',
    state_code: '',
  },
  crm: '',
  voter_registration: '',
  income_tax: '',
  pis: '',
  has_cnh: '',
  government_employee: '',
  contributor_inss: '',
  is_other_company_partner: '',
  race: '',
}

export const ethnicDisclaimerText =
  'Esta autodeclaração atende à exigência do art. 39, § 8º, da Lei nº 12.288/2010, alterado pela Lei nº 14.553/2023, e da Portaria MTE nº 3.784/2023, que obriga a prestação da informação nas inclusões, alterações ou retificações cadastrais dos trabalhadores ocorridas a partir de 1º de janeiro de 2024, respeitando o critério de autodeclaração do trabalhador, em conformidade com a classificação utilizada pelo Instituto Brasileiro de Geografia e Estatística - IBGE.'
